<template lang="pug">
  form.card(@submit.prevent="$emit('submit')" :class="loading?'loading':''")
    .card-body
      .alert.alert-danger(v-if="Object.keys(errors).length")
        b Error
        ul.mb-0(v-for="item in errors")
          li(v-for="error in item") {{error}}
      vue-form-generator.row.justify-content-around(:schema="schema" :model="value" tag="div" :options="formOptions")
      .d-flex.justify-content-end
        loading_button.btn.btn-primary(type="submit" :loading="loading") Save
</template>

<script>
import loading_button from '@/components/loadingBtn'

export default {
  props: ['errors', 'schema', 'value', 'loading'],
  data(){
    return{
      form: this.value,
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },
  components:{
    loading_button
  }
}
</script>